// src/api/travel.service.js
import API from './axiosConfig';

// Public endpoints
export const getCountries = () => API.get('/api/countries');
export const getDestinations = (countryId) => API.get(`/api/destinations/${countryId}`);

// ✅ FIXED: Only destinationId, no category
export const getActivities = (destinationId) => API.get(`/api/activities/${destinationId}`);

// Admin endpoints
export const getUnassignedDestinations = async () => {
  try {
    const response = await API.get('/api/admin/unassigned-destinations');
    if (response.data?.status === true && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (error) {
    console.error('Error in getUnassignedDestinations:', error);
    return { data: [] };
  }
};

export const getUnassignedActivities = async () => {
  try {
    const response = await API.get('/api/admin/unassigned-activities');
    if (response.data?.status === true && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (error) {
    console.error('Error in getUnassignedActivities:', error);
    return { data: [] };
  }
};

export const getAllDestinations = async () => {
  try {
    const response = await API.get('/api/admin/all-destinations');
    if (response.data?.status === true && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (error) {
    console.error('Error in getAllDestinations:', error);
    return { data: [] };
  }
};

export const getAllActivities = async () => {
  try {
    const response = await API.get('/api/admin/all-activities');
    if (response.data?.status === true && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (error) {
    console.error('Error in getAllActivities:', error);
    return { data: [] };
  }
};

export const getAllCountries = async () => {
  try {
    const response = await API.get('/api/admin/all-countries');
    if (response.data?.status === true && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (error) {
    console.error('Error in getAllCountries:', error);
    return { data: [] };
  }
};

export const assignDestination = async (data) => {
  try {
    const response = await API.post('/api/admin/assign-destination', data);
    return response.data;
  } catch (error) {
    console.error('Error in assignDestination:', error);
    throw error;
  }
};

export const assignActivity = async (data) => {
  try {
    const response = await API.post('/api/admin/assign-activity', data);
    return response.data;
  } catch (error) {
    console.error('Error in assignActivity:', error);
    throw error;
  }
};
export const getDestinationById = async (destinationId) => {
  try {
    const response = await API.get(`/api/destinations/${destinationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching destination:', error);
    return { status: false, data: null };
  }
};